import React from 'react';
import { CssBaseline, Badge, Grid, Typography, withStyles } from '@material-ui/core';
import LiveTopbar from '../components/LiveTopbar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import VideoPlayer from '../components/VideoPlayer';
import { EVENT_ID, getUserID, LOGIN_TB, SIGNOUT_URL, TEST_VIDEO } from '../constants';

import queryString from 'querystring';
import Chat from './sessionComp/Chat';
import ConfirmDialog from '../components/dialogs/ConfirmDialog';
import ProgramDialog from '../program/ProgramDialog';
import AttendCheckDialog from './sessionComp/AttendCheckDialog';
import { Auth } from 'aws-amplify';
import Emergency from '../components/dialogs/Emergency';
// import Button from '@material-ui/core/Button';
// import { Home } from '@material-ui/icons';
import Vote from './sessionComp/Vote';
import QNA from './sessionComp/QNA';
import QuizButton from './sessionComp/QuizButton';
import EMAlert from '../components/EMAlert';
import SocketManager from '../components/SocketManager';
import moment from 'moment-timezone';
// import ChannelTabs from './sessionComp/ChannelTabs';
// import SimpleAdvertising from './banner/SimpleAdvertising';

import { ImExit } from 'react-icons/im';
import { ImCalendar } from 'react-icons/im';
import { IoMdCheckboxOutline } from 'react-icons/io';
import ProgramDetail from '../program/ProgramDetail';

const styles = (theme) => ({
  container: {
    display: 'flex',
    backgroundColor: 'white',
    // height: 'calc(100% - 89px)',
    height: '100%',
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      height: 'calc(100% - 81px - 48px)',
    },
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
    '& .MuiTypography-root': {
      padding: '0px !important',
    },
  },
  main: {
    height: 'calc(100vh - 86px)',
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      height: '100%',
    },
    // overflowY: 'auto',
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  footer: {
    backgroundColor: '#ffffff',
    position: 'relative',
    width: '100%',
    marginLeft: '90px',
  },
  rightWrap: {
    [theme.breakpoints.down('sm')]: {
      borderLeft: 'none',
      //height: '80%',
    },
  },
  tabContainer: {
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  tabPanel: {
    height: '75vh',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },

  //동영상영역
  videoGrid: {
    height: '100%',
    borderRight: '1px solid #f5f5f5',
    [theme.breakpoints.down('sm')]: {
      borderRight: 'none',
    },
  },
  bottoms: {
    [theme.breakpoints.up('md')]: {
      // position: 'absolute',
      bottom: 0,
      left: 0,
      zIndex: 999,
    },
  },
  buttons: {
    marginTop: '10px',
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      width: '100%',
    },
  },
  //우측하단 버튼 영역
  bottomBtns: {
    borderTop: '1px solid #f5f5f5',
    height: '6%',
    padding: '1em 0',
    // backgroundColor: '#ffffff',
    backgroundColor: theme.palette.primary.main,
    '& div': {
      // cursor: 'pointer',
      // color: theme.palette.primary.main,
      color: '#fff',
      fontWeight: 'bold',
      textAlign: 'center',
    },
  },
  moveChannel: {
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
      flexDirection: 'column',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9em',
      flexDirection: 'row',
    },
    '& br': {
      display: 'none',
      [theme.breakpoints.down('lg')]: {
        display: 'block',
      },
    },
  },
  //배너영역
  adWeb: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  adMob: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  containerInner: {
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
});

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3, backgroundColor: '#ffffff' /*, height: '100%' */ }}>
      {props.children}
    </Typography>
  );
}

class LivePage extends React.Component {
  constructor(props) {
    super(props);
    let param = queryString.parse(this.props.location.search.replace('?', ''));

    this.refChat = React.createRef();
    this.refLiveTopBar = React.createRef();

    this.state = {
      value: 'Chat',
      date1: false,
      date2: false,
      date3: false,
      date1Hovered: false,
      date2Hovered: false,
      date3Hovered: false,
      msg: '',
      channelId: param.ch,
      username: sessionStorage.getItem('_in_name'),
      openConfirmPopup: false,
      now: new Date(),
      openEmergencyPopup: false,
      openProgramDialog: false,
      openAttendCheckDialog: false,
      noticeContent: '',
      noticeTitle: '',
      session: '',
      isIE: null,
      eventInfo: sessionStorage.getItem('Item') ? JSON.parse(sessionStorage.getItem('Item')) : null,
      program: {},
      showQuiz: false,
    };

    this.handleDate = this.handleDate.bind(this);
    this.handleHover = this.handleHover.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.liveLogout = this.liveLogout.bind(this);
    this.doClose = this.doClose.bind(this);
    this.moveRoom = this.moveRoom.bind(this);
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.onBeforeUnload);
    this.init();
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.onBeforeUnload);
  }

  onBeforeUnload = (e) => {
    if (!sessionStorage.getItem('_in_user_')) {
      return;
    }
    try {
      this.refLiveTopBar.current.goExit(null, true);
    } catch (err) {}

    e.preventDefault();
    // const confirmationMessage = `강의창 종료 전, '이수하기'버튼을 클릭하셔야 퇴장시간 확인이 가능합니다. 종료하시겠습니까?`;

    const confirmationMessage = `Before the lecture window ends,  button to check the departure time. Are you sure you want to quit?`;

    (e || window.event).returnValue = confirmationMessage; //Gecko + IE, Chrome(mac os)

    return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
  };

  init() {
    const eventItem = sessionStorage.getItem('Item');
    let jsonItem = null;
    if (!eventItem) this.props.history.push('/main');
    else {
      jsonItem = JSON.parse(eventItem);
      this.setState({ eventInfo: jsonItem });

      // [Start] QUIZ 여부 체크 - 둘째날 채널 06
      const today = moment().format('YYYYMMDD');
      const second = moment(jsonItem.startDate, 'YYYYMMDD').add(1, 'd');
      if (second.format('YYYYMMDD') === today && this.state.channelId === 'Channel01') {
        this.setState({ second: second.format('YYYYMMDD'), showQuiz: true }, () => {
          console.log('second: ', this.state.second);
        });
      }
      // [End] Quiz

      const pos = jsonItem.channel
        .map(function (e) {
          return e.name;
        })
        .indexOf(this.state.channelId);
      this.setState({ channel: jsonItem.channel }, () => {
        console.log('CHANNEL: ', this.state.channel);
      });
      this.setState({ callFunction: pos /*+ 1*/ }, () => {
        console.log('callFunc', this.state.callFunction);
      });
    }
  }

  liveLogout() {
    this.setState({ openConfirmPopup: true, isShowConfirm: true });
  }

  doClose(event, _val) {
    if (_val === 'Y') {
      try {
        this.refLiveTopBar.current.goExit();
      } catch (err) {
        console.log(err);
      }

      setTimeout(function () {
        if (sessionStorage.getItem('_in_name')) {
          fetch(
            `${SIGNOUT_URL}?username=${encodeURIComponent(
              sessionStorage.getItem('_in_name'),
            )}&userid=${getUserID()}&evt=${EVENT_ID}&tbName=${LOGIN_TB}&agent=${encodeURIComponent(navigator.userAgent)}`,
            {
              method: 'GET',
            },
          )
            .then(() => {})
            .catch((err) => {
              console.log(err);
            });
        }

        localStorage.clear();
        sessionStorage.clear();
        Auth.signOut().then(() => {
          window.opener = 'Self';
          window.close(); // 일반적인 현재 창 닫기
          // window.open('', '_parent', '');
          // window.open('about:blank', '_self').self.close(); // IE에서 묻지 않고 창 닫기
        });
      }, 1000);
    } else {
      this.setState({ openConfirmPopup: false });
    }
  }

  handleUnload() {
    return 'exit';
  }

  handleChange(event, newVal) {
    this.setState({ value: newVal });
  }

  handleState(key, value) {
    this.setState((prevState) => ({
      [key]: value,
    }));
  }

  handleHover(e) {
    const strId = e.target.id + 'Hovered';
    this.setState({
      [strId]: true,
    });
  }

  closeEmergencyDialog = (event) => {
    this.setState({ openEmergencyPopup: false });
  };

  closeProgramDialog = (event) => {
    this.setState({ openProgramDialog: false });
  };

  closeAttendCheckDialog = (event) => {
    this.setState({ openAttendCheckDialog: false });
  };

  handleDate(e, idx) {
    for (let i = 1; i <= 3; i++) {
      this.setState({ ['date' + i]: false });
    }
    this.setState({ [idx]: true });
  }

  onSetSession = (session) => {
    if (this.state.session !== session) {
      this.refChat.current.clearChatList();
    }

    this.setState({ session: session });
  };

  moveRoom(channelId) {
    // this.setState({ opened: true });
    // if (this.state.win) {
    //   this.state.win.close();
    // }
    // this.liveLogout(null, 'Y');
    if (this.state.win) {
      this.state.win.close();
    }

    this.setState({ channelId });

    window.location.href = `/#/live?ch=${channelId}`;
    window.location.reload();

    // this.liveLogout(null, 'Y');
    // this.refLiveTopBar.current.handleCheckout().then(() => {
    //   if (this.state.win) {
    //     this.state.win.close();
    //   }

    //   this.setState({ channelId });

    //   window.location.href = `/#/live?ch=${channelId}`;
    //   window.location.reload();
    // });

    // setTimeout(() => {
    //   this.refTopBar.current.refreshTitle(ch);
    // }, 500);

    // if (ch === 'ChannelA') {
    //   this.setState({ channelId: 'ChannelB' }, () => {
    //     console.log('현재 접속한 방: ' + this.state.channelId);
    //   });
    //
    //   window.location.href = `/#/live?ch=ChannelB`;
    //   window.location.reload();
    // } else {
    //   this.setState({ channelId: 'ChannelA' }, () => {
    //     console.log('현재 접속한 방: ' + this.state.channelId);
    //   });
    //   window.location.href = `/#/live?ch=ChannelA`;
    //   window.location.reload();
    // }
    // setTimeout(() => {
    //   this.refTopBar.current.refreshTitle(ch);
    // }, 500);
  }

  render() {
    const { classes } = this.props;
    const { value } = this.state;

    return (
      <React.Fragment>
        <div style={{ height: '100%', overflow: 'auto' }}>
          <CssBaseline />
          <LiveTopbar
            ref={this.refLiveTopBar}
            ch={this.state.channelId}
            callFunc={this.state.callFunction}
            setSession={this.onSetSession}
            handleState={this.handleState.bind(this)}
          />
          <main
            className={classes.main}
            style={
              navigator.userAgent.toLowerCase().indexOf('msie') !== -1 ||
              navigator.userAgent.toLowerCase().indexOf('ie') !== -1 ||
              navigator.userAgent.toLowerCase().indexOf('trident') !== -1
                ? { height: '100%' }
                : {}
            }
          >
            <div
              className={classes.container}
              style={
                navigator.userAgent.toLowerCase().indexOf('msie') !== -1 ||
                navigator.userAgent.toLowerCase().indexOf('ie') !== -1 ||
                navigator.userAgent.toLowerCase().indexOf('trident') !== -1
                  ? { height: 'calc(100% - 81px - 113px)' }
                  : {}
              }
            >
              {/* End hero unit */}
              <Grid container spacing={0}>
                <Grid item xs={12} md={9} className={classes.containerInner}>
                  {/* <Grid container>
                    <ChannelTabs channel={this.state.channel} ch={this.state.channelId} moveRoom={this.moveRoom} />
                  </Grid> */}
                  <Grid
                    container
                    spacing={0}
                    direction={'row'}
                    justifyContent={'space-between'}
                    alignItems={'flex-start'}
                    className={classes.videoGrid}
                  >
                    {this.state.channel && this.state.channel.length > 0 ? (
                      <VideoPlayer
                        src={this.state.channel[this.state.callFunction].url ? this.state.channel[this.state.callFunction].url : TEST_VIDEO}
                        // src={TEST_VIDEO}
                        type={this.state.eventInfo.playerType ? this.state.eventInfo.playerType : 'jw'}
                        pos={'live'}
                      />
                    ) : (
                      ''
                    )}
                  </Grid>
                  {/* <SimpleAdvertising channel={this.state.channelId} /> */}
                </Grid>

                <Grid item xs={12} md={3} className={classes.rightWrap}>
                  {/* <Grid container justifyContent="center" item xs={12}>
                    <SimpleAdvertising channel={this.state.channelId} />
                  </Grid> */}
                  <Tabs value={value} indicatorColor="primary" textColor="primary" aria-label="tabs" onChange={this.handleChange}>
                    <Tab
                      label="Chat"
                      value="Chat"
                      style={{
                        minWidth: '80px',
                        fontWeight: 'bold',

                        // border: '1px solid #025a3c',
                        // borderRadius: '5px',
                      }}
                    />

                    {this.state.eventInfo && this.state.eventInfo.useVoting && this.state.channelId === 'Channel04' && (
                      <Tab label="Voting" value="Voting" style={{ minWidth: '80px', fontWeight: 'bold' }} />
                    )}
                    {this.state.eventInfo && this.state.channelId === 'Channel01' && (
                      <Tab
                        label={
                          <Badge
                            badgeContent={''}
                            color="Primary"
                            variant="dot"
                            anchorOrigin={{
                              vertical: 'top',
                              horizontal: 'right',
                            }}
                          >
                            <span>QUIZ (08:00~18:30)</span>
                          </Badge>
                        }
                        value="Quiz"
                        style={{
                          minWidth: '160px',
                          fontWeight: 'bold',
                          borderRadius: '5px',
                          // backgroundColor: 'rgba(2,90,60,0.25)',
                          border: '2px solid',
                          borderColor: 'rgba(2,90,60,0.25)',
                        }}
                      />
                    )}

                    {/* <Tab label="Voting" value="Voting" style={{ minWidth: '80px', fontWeight: 'bold' }} /> */}
                    {/* {this.state.eventInfo && this.state.eventInfo.useChat && (
                      <Tab label="Chat" value="Chat" style={{ minWidth: '80px', fontWeight: 'bold' }} />
                    )}
                    {this.state.eventInfo && this.state.eventInfo.useQna && (
                      <Tab label="QNA" value="QNA" style={{ minWidth: '80px', fontWeight: 'bold' }} />
                    )}

                    {this.state.eventInfo && this.state.eventInfo.useVoting && (
                      <Tab label="Voting" value="Voting" style={{ minWidth: '80px', fontWeight: 'bold' }} />
                    )} */}
                  </Tabs>
                  {/* <p
                    style={{
                      lineHeight: '20px',
                      padding: '10px',
                      backgroundColor: '#f4f4f4',
                      color: this.props.theme.palette.primary.main,
                      fontWeight: 500,
                      textAlign: 'center',
                    }}
                  >
                    세션과 관련된 내용만 질문해 주시기 바랍니다.
                  </p> */}
                  {value === 'Chat' && (
                    <TabContainer>
                      <Chat ref={this.refChat} channel={this.state.channelId} session={this.state.session} />
                    </TabContainer>
                  )}

                  {value === 'QNA' && (
                    <TabContainer className={classes.tabContainer}>
                      <QNA style={{ overflowY: 'scroll' }} channel={this.state.channelId} />
                    </TabContainer>
                  )}

                  {value === 'Quiz' && (
                    <TabContainer className={classes.tabContainer}>
                      <QuizButton style={{ overflowY: 'scroll' }} channel={this.state.channelId} />
                    </TabContainer>
                  )}
                  {value === 'Voting' && (
                    <TabContainer className={classes.tabContainer}>
                      <Vote style={{ overflowY: 'scroll' }} channel={this.state.channelId} count={6} />
                    </TabContainer>
                  )}
                  <Grid item xs={12} className={classes.buttons}>
                    <Grid>
                      <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        className={classes.bottomBtns}
                        style={window.matchMedia('(max-width:400px)').matches ? { fontSize: '11px' } : {}}
                      >
                        <Grid item xs={4} onClick={this.liveLogout} style={{ cursor: 'pointer', zIndex: 999 }}>
                          <ImExit style={{ width: '20px', height: '20px', color: '#08d8a1' }} />
                          <p>Exit</p>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          style={{ borderLeft: '1px solid #e1e1e1', borderRight: '1px solid #e1e1e1', cursor: 'pointer' }}
                          onClick={() => {
                            this.setState({ openProgramDialog: true });
                          }}
                        >
                          <ImCalendar style={{ width: '20px', height: '20px', color: '#08d8a1' }} />
                          <p>Program at a Glance</p>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          onClick={() => {
                            this.setState({ openAttendCheckDialog: true });
                          }}
                          style={{ zIndex: 999 }}
                        >
                          <IoMdCheckboxOutline style={{ width: '20px', height: '20px', color: '#08d8a1' }} />

                          <p>My Page</p>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
            {/* 현재 프로그램 상세 정보 */}
            {this.state.program && this.state.program.id && (
              <ProgramDetail isLive={true} channelId={this.state.channelId} program={this.state.program} />
            )}
          </main>
        </div>

        <Emergency
          open={this.state.openEmergencyPopup}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ openEmergencyPopup: false });
            }
          }}
          // onClose={this.closeEmergencyDialog}
          // disableBackdrop={true}
          noticeContent={this.state.noticeContent}
          noticeTitle={this.state.noticeTitle}
        />
        <ProgramDialog
          open={this.state.openProgramDialog}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ openProgramDialog: false });
            }
          }}
          // onClose={this.closeProgramDialog} disableBackdrop={true}
        />
        <AttendCheckDialog
          open={this.state.openAttendCheckDialog}
          //  onClose={this.closeAttendCheckDialog} disableBackdrop={true}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ openAttendCheckDialog: false });
            }
          }}
        />
        <ConfirmDialog
          open={this.state.openConfirmPopup}
          // onClose={(event, reason) => {
          //   if (reason !== 'backdropClick') {
          //     this.doClose();
          //   }
          // }}
          onClose={this.doClose}
          // disableBackdrop={true}
          title={''}
          // msg={"강의창 종료 전, '이수하기'버튼을 클릭하셔야 퇴장시간 확인이 가능합니다. 종료하시겠습니까?"}
          msg={
            <div style={{ fontWeight: 'bold' }}>
              [For Korean CME]
              <br />
              우측 상단의 Session Out을 클릭 후, 퇴장하셔야 평점이 인정됩니다. 퇴장하시겠습니까?
              <br /> <br />
              Do you want to quit?
            </div>
          }
        />
        <EMAlert topic={`room/public/${EVENT_ID}/${this.state.channelId}/+`} channel={this.state.channelId} />
        {this.state.eventInfo && this.state.eventInfo.useLoginCheck && <SocketManager winClose={true} />}
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(LivePage);
